import { useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';

const drawerWidth = 248;

const useStyles = makeStyles((theme: Theme) =>
   createStyles({
      root: {
         display: 'flex',
      },
      appBar: {
         backgroundColor: theme.palette.background.paper,
         zIndex: theme.zIndex.drawer + 1,
         transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
         }),
         borderBottom: '1px solid gainsboro',
         boxShadow: 'none',
      },
      appBarShift: {
         marginLeft: drawerWidth,
         width: `calc(100% - ${drawerWidth}px)`,
         transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
         }),
      },
      menuButton: {
         marginRight: 36,
      },
      hide: {
         display: 'none',
      },
      drawer: {
         width: drawerWidth,
         flexShrink: 0,
         whiteSpace: 'nowrap',
      },
      drawerOpen: {
         width: drawerWidth,
         transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
         }),
      },
      drawerClose: {
         transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
         }),
         overflowX: 'hidden',
         width: theme.spacing(5) + 1,
         [theme.breakpoints.up('sm')]: {
            width: theme.spacing(7) + 1,
         },
      },
      toolbar: {
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'flex-end',
         padding: theme.spacing(0, 1),
         // necessary for content to be below app bar
         ...theme.mixins.toolbar,
      },
      content: {
         flexGrow: 1,
         overflowY: 'auto',
         padding: theme.spacing(3),
         [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
         },
         position: 'relative',
         minHeight: '100vh',
         boxSizing: 'border-box',
      },
      noPadcontent: {
         flexGrow: 1,
         overflowY: 'auto',
         padding: theme.spacing(0),
         [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
         },
      },
      outline: {
         '& .MuiOutlinedInput-root': {
            '& fieldset': {
               borderColor: theme.palette.primary.light,
               borderRadius: '5px 0px 0px 5px',
               [theme.breakpoints.up('md')]: {
                  borderRadius: '0px',
               },
            },
         },
         '& .MuiOutlinedInput-adornedStart': {
            [theme.breakpoints.up('md')]: {
               paddingLeft: 0,
            },
         },
         '& .MuiOutlinedInput-adornedEnd': {
            paddingRight: 0,
         },
      },
      iconButton: {
         '&:focus': {
            outline: 'none',
         },
         border: `1px solid ${theme.palette.primary.light}`,
         padding: '7px',
         marginTop: '4px',
      },
      icon: {
         fontSize: '12px',
      },
   }),
);
export { useStyles };
